import React from 'react';
import {useDrop} from 'react-dnd';

const TaskItemDynamic = ({word, selectedWord, setSelectedWord, onChange}) => {
  const [{isOver}, drop] = useDrop({
    accept: 'answer',
    drop: item => {
      onChange(item.word);
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <span
      ref={drop}
      onClick={() => {
        if (selectedWord) {
          onChange(selectedWord);
          setSelectedWord(null);
        }
      }}
      className={
        'border border-dark user-select-none rounded d-flex px-75 flex-column justify-content-center text-center mb-1 ' +
        (isOver ? 'bg-primary' : 'bg-warning') +
        (selectedWord ? ' cursor-pointer' : '')
      }
      style={{
        minWidth: '4rem',
        minHeight: '34px',
        marginRight: '0.17rem',
        zIndex: 1,
      }}
    >
      {word.slice(1)}
    </span>
  );
};

export default TaskItemDynamic;
